const faqs = [
  {
    q: '51吃瓜黑料网是什么？',
    a: '51吃瓜黑料网是一个聚合全网热门事件与吃瓜爆料的资讯平台。我们实时盘点娱乐圈、网红圈、社会热点等各类话题，为吃瓜群众提供最快、最全的热点事件汇总和网友热议入口。',
  },
  {
    q: '网站内容每天更新吗？',
    a: '是的，我们保持全天候更新节奏。编辑团队24小时不间断追踪各大平台热点，确保你打开网站就能看到最新鲜的吃瓜内容。热门事件从发酵到引爆，我们全程跟踪。',
  },
  {
    q: '我可以参与讨论吗？',
    a: '当然可以！51吃瓜黑料网鼓励吃瓜群众在每篇内容下方发表观点。你也可以通过话题标签找到感兴趣的事件，与数万网友一起围观讨论。理性吃瓜，文明发言。',
  },
  {
    q: '如何下载吃瓜App？',
    a: '你可以在App Store或各大安卓应用商店搜索「51吃瓜」下载官方App。移动端支持推送通知和离线阅读，让你随时随地掌握最新爆料动态。',
  },
  {
    q: '网站内容可靠吗？',
    a: '我们致力于聚合来自可靠渠道的公开信息，所有内容均标注来源。对于未经验证的传闻，我们会明确标注「待证实」。吃瓜需理性，我们倡导健康、文明的吃瓜文化。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            关于51吃瓜黑料网，你想知道的都在这里
          </p>
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-background-50 rounded-lg p-5 md:p-6">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                  {faq.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}